import React from 'react';
import {
  Table,
} from 'react-bootstrap';

import '../style.css';

const JobApprovalsInboxLegend = () => {
  return (
    <div>
      <Table>
        <thead>
          <tr>
            <th>Color</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span className="staged-icon-color color-block-width">&nbsp;</span>
            </td>
            <td>Waiting On Manager Approval</td>
          </tr>
          <tr>
            <td>
              <span className="unreviewed-icon-color color-block-width">&nbsp;</span>
            </td>
            <td>Waiting On Field Admin Approval</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default JobApprovalsInboxLegend;
